"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionOrderTypeCreateReducer = exports.subscriptionOrderTypeFetchReducer = exports.subscriptionOrderTypeCreateSlice = exports.subscriptionOrderTypeFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const subsOrderTypeAction_1 = require("./subsOrderTypeAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.subscriptionOrderTypeFetchSlice = (0, toolkit_1.createSlice)({
    name: 'subscriptionPurchaseOrderType/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subsOrderTypeAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(subsOrderTypeAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(subsOrderTypeAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.subscriptionOrderTypeCreateSlice = (0, toolkit_1.createSlice)({
    name: 'subscriptionPurchaseOrderType/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subsOrderTypeAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(subsOrderTypeAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(subsOrderTypeAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.subscriptionOrderTypeFetchReducer = exports.subscriptionOrderTypeFetchSlice.reducer;
exports.subscriptionOrderTypeCreateReducer = exports.subscriptionOrderTypeCreateSlice.reducer;
